import React from 'react';
import { BodyText, StickyCell } from './blocks';

// Cells clip overflowing content (see blocks.js StickyCell/BodyText) so long values
// can't bleed into neighboring columns. When the content is actually truncated,
// expose the full text as a hover tooltip.
const showFullTextOnTruncation = (e) => {
    const el = e.currentTarget;
    if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) {
        el.title = el.textContent || '';
    } else {
        el.removeAttribute('title');
    }
};

export default function BodyCell({ cell, callbacks = {}, isChecked, ...props }) {
    return (
        <StickyCell align="left" {...props}>
            <BodyText onMouseEnter={showFullTextOnTruncation}>{cell.render('Cell', { callbacks, isChecked })}</BodyText>
        </StickyCell>
    );
}
